export enum DimensionSourceScale {
  DownOnly = 'DownOnly',
  UpOnly = 'UpOnly',
  Both = 'Both',
}
